import { render, staticRenderFns } from "./MobileCameraMonitor.vue?vue&type=template&id=3956687c&scoped=true&"
import script from "./MobileCameraMonitor.vue?vue&type=script&lang=js&"
export * from "./MobileCameraMonitor.vue?vue&type=script&lang=js&"
import style0 from "./MobileCameraMonitor.vue?vue&type=style&index=0&id=3956687c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956687c",
  null
  
)

export default component.exports